




























import { Component, Inject, Vue } from "vue-property-decorator";
import {
  IFraudMindProvider,
  IFraudMindProviderMethods
} from "@/models/providers/fraud";
import { FraudPoliciesMap, FraudStatus, FraudPolicies } from "@/data/fraud";

@Component
export default class FraudPolicySelect extends Vue {
  // Inject
  @Inject({ from: "fraudMindProvider" })
  public $fraudProvider!: () => IFraudMindProvider;
  @Inject({ from: "fraudMindProviderMethods" })
  public $fraudMethods!: IFraudMindProviderMethods;
  // Data
  public isProcessing = false;
  public fraudPoliciesMap = FraudPoliciesMap();
  // Computed
  public get fraudProvider() {
    return this.$fraudProvider();
  }
  public get policies() {
    return this.$_.orderBy(this.fraudPoliciesMap, ["order", "asc"]);
  }
  public get isFutilePolicy() {
    return (
      this.fraudProvider.clientPolicy !== FraudPolicies.NEUTRAL &&
      [FraudStatus.REVIEW, FraudStatus.FRAUD].includes(
        this.fraudProvider.fraudStatusId
      )
    );
  }
  // Methods
  public async onPolicyChange(policy) {
    if (this.isProcessing) return;
    try {
      this.isProcessing = true;
      await this.$fraudMethods.setClientPolicy(policy);
    } finally {
      this.isProcessing = false;
    }
  }
}
